import styled from 'styled-components'
import { CLICKABLE_COLOR } from '@CSSVars/colors'

export const _Recaptcha = styled.div`
  max-width: 100%;
  flex-basis: 100%;
  padding: 0 8px;
  margin-top: 16px;
  //line-height: 20px;
  span {
    font-size: 12px;
  }

  a {
    font-size: inherit;
    text-decoration: underline;
    color: ${CLICKABLE_COLOR};
  }
)}
  `
